import { isValid, parse } from "date-fns";

export const DATE_FORMAT = "dd/MM/yyyy";
export const TIME_FORMAT = "HH'h'mm";

export const toLocaleDateString = (date: Date, locale = "fr-FR"): string => {
  return date.toLocaleDateString(locale);
};

const DD_MM_YYYY_REGEX = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
const ISO_DATE_FORMAT = "yyyy-MM-dd";
const REFERENCE_DATE = new Date(0);

export const toISODateOnly = (date: Date): string => {
  return date.toISOString().slice(0, 10);
};

export const toUtcCalendarDate = (isoDate: string): Date => {
  const [year, month, day] = isoDate.split("-").map(Number);

  return new Date(Date.UTC(year ?? 0, (month ?? 1) - 1, day ?? 0, 12, 0, 0));
};

export const shiftIsoDate = (isoDate: string, dayOffset: number): string => {
  const shiftedDate = toUtcCalendarDate(isoDate);
  shiftedDate.setUTCDate(shiftedDate.getUTCDate() + dayOffset);
  return toISODateOnly(shiftedDate);
};

export const tryParseISODate = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) {
    return null;
  }

  const ddmmyyyy = DD_MM_YYYY_REGEX.exec(trimmed);
  const dateToParse = ddmmyyyy
    ? `${ddmmyyyy[3]}-${(ddmmyyyy[2] ?? "").padStart(2, "0")}-${(ddmmyyyy[1] ?? "").padStart(2, "0")}`
    : trimmed.slice(0, 10);

  const parsed = parse(dateToParse, ISO_DATE_FORMAT, REFERENCE_DATE);
  if (!isValid(parsed)) {
    return null;
  }

  // Round-trip check: reject dates that were silently normalized (e.g. Feb 31 → Mar 3)
  const [y, m, d] = dateToParse.split("-").map(Number);
  if (parsed.getFullYear() !== y || parsed.getMonth() + 1 !== m || parsed.getDate() !== d) {
    return null;
  }

  return dateToParse;
};
